<template>
  <header class="sticky top-0 z-40 bg-white shadow-sm border-b border-gray-200">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center h-16">
        <!-- Левая часть: Логотип -->
        <div class="flex items-center">
          <Logo />
        </div>

        <!-- Центральная часть: Навигация и поиск -->
        <div class="flex-1 flex items-center justify-center space-x-8 max-w-2xl mx-8">
          <!-- Навигационные ссылки (скрыты на мобильных) -->
          <NavigationLinks />
          
          <!-- Поиск моделей (скрыт на мобильных) -->
          <div class="hidden md:block">
            <SearchModelsInput />
          </div>
        </div>

        <!-- Правая часть: Пользовательское меню и мобильная кнопка -->
        <div class="flex items-center space-x-4">
          <!-- Кнопки для неавторизованных пользователей -->
          <div v-if="!authStore.isAuthenticated" class="hidden sm:flex items-center space-x-2">
            <button
              class="bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-lg font-medium transition-colors"
              @click="handleDemoLogin"
            >
              Demo Login
            </button>
            <router-link
              to="/signin"
              class="bg-primary-500 hover:bg-primary-600 text-white px-4 py-2 rounded-lg font-medium transition-colors"
            >
              Sign In
            </router-link>
          </div>

          <!-- Пользовательское меню для авторизованных -->
          <UserMenu v-if="authStore.isAuthenticated" />

          <!-- Кнопка мобильного меню (скрыта на страницах аккаунта) -->
          <button
            v-if="!isAccountPage"
            class="md:hidden p-2 rounded-lg text-gray-600 hover:text-gray-900 hover:bg-gray-50 transition-colors"
            @click="toggleMobileMenu"
          >
            <Bars3Icon v-if="!isMobileMenuOpen" class="w-6 h-6" />
            <XMarkIcon v-else class="w-6 h-6" />
          </button>
        </div>
      </div>

      <!-- Мобильное меню (скрыто на страницах аккаунта) -->
      <transition
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-75 ease-in"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-95 opacity-0"
      >
        <div
          v-if="isMobileMenuOpen && !isAccountPage"
          class="md:hidden border-t border-gray-200 bg-white"
        >
          <div class="px-4 py-4 space-y-4">
            <!-- Поиск для мобильных -->
            <SearchModelsInput />
            
            <!-- Навигация для мобильных -->
            <NavigationLinks mobile />
            
            <!-- Кнопка входа для мобильных (если не авторизован) -->
            <div v-if="!authStore.isAuthenticated" class="pt-4 border-t border-gray-200">
              <router-link
                to="/signin"
                class="block w-full bg-primary-500 hover:bg-primary-600 text-white px-4 py-2 rounded-lg font-medium text-center transition-colors"
                @click="closeMobileMenu"
              >
                Sign In
              </router-link>
            </div>

            <!-- Дополнительные кнопки для демонстрации -->
            <div v-if="!authStore.isAuthenticated" class="pt-2">
              <button
                class="block w-full bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-lg font-medium text-center transition-colors"
                @click="handleDemoLogin"
              >
                Demo Login
              </button>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useRoute } from 'vue-router'
import { Bars3Icon, XMarkIcon } from '@heroicons/vue/24/outline'

// Компоненты
import Logo from './Logo.vue'
import NavigationLinks from './NavigationLinks.vue'
import SearchModelsInput from './SearchModelsInput.vue'
import UserMenu from './UserMenu.vue'

// Удалили emits, так как Header теперь не управляет sidebar на страницах аккаунта

const authStore = useAuthStore()
const route = useRoute()

// State для мобильного меню
const isMobileMenuOpen = ref(false)

// Computed
const isAccountPage = computed(() => {
  return route.path.startsWith('/account')
})

// Methods
function toggleMobileMenu() {
  // Управляем только внутренним мобильным меню Header'а
  isMobileMenuOpen.value = !isMobileMenuOpen.value
}

function closeMobileMenu() {
  isMobileMenuOpen.value = false
}

function handleDemoLogin() {
  authStore.loginDemo()
  closeMobileMenu()
}

// При смене маршрута закрываем мобильное меню
import { useRouter } from 'vue-router'
const router = useRouter()

router.afterEach(() => {
  closeMobileMenu()
})
</script> 